"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RulerSpriteInfo = exports.RulerStyleInfo = exports.RulerTabImages = exports.RulerStyles = exports.RulerTitles = exports.RulerVisibility = exports.RulerSettings = exports.RULLER_NUMBER_CORRECTION = exports.RULER_CLASS_NAME = exports.RICH_EDIT_CLASS_NAME_PREFIX = void 0;
exports.RICH_EDIT_CLASS_NAME_PREFIX = "dxre-";
exports.RULER_CLASS_NAME = exports.RICH_EDIT_CLASS_NAME_PREFIX + "ruler";
exports.RULLER_NUMBER_CORRECTION = 5;
var RulerSettings = (function () {
    function RulerSettings() {
    }
    return RulerSettings;
}());
exports.RulerSettings = RulerSettings;
var RulerVisibility;
(function (RulerVisibility) {
    RulerVisibility[RulerVisibility["Auto"] = 0] = "Auto";
    RulerVisibility[RulerVisibility["Visible"] = 1] = "Visible";
    RulerVisibility[RulerVisibility["Hidden"] = 2] = "Hidden";
})(RulerVisibility = exports.RulerVisibility || (exports.RulerVisibility = {}));
var RulerTitles = (function () {
    function RulerTitles() {
    }
    return RulerTitles;
}());
exports.RulerTitles = RulerTitles;
var RulerStyles = (function () {
    function RulerStyles() {
    }
    return RulerStyles;
}());
exports.RulerStyles = RulerStyles;
var RulerTabImages = (function () {
    function RulerTabImages() {
    }
    return RulerTabImages;
}());
exports.RulerTabImages = RulerTabImages;
var RulerStyleInfo = (function () {
    function RulerStyleInfo() {
    }
    return RulerStyleInfo;
}());
exports.RulerStyleInfo = RulerStyleInfo;
var RulerSpriteInfo = (function () {
    function RulerSpriteInfo() {
    }
    return RulerSpriteInfo;
}());
exports.RulerSpriteInfo = RulerSpriteInfo;
